@file:OptIn(InternalResourceApi::class)

package gamerlogue.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gamerlogue.sharedui.generated.resources/"

@delegate:ResourceContentHash(1_721_038_451)
internal val Res.string.review_aspect__cast: StringResource by lazy {
      StringResource("string:review_aspect__cast", "review_aspect__cast", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29622, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27618, 51),
      ))
    }

@delegate:ResourceContentHash(1_118_751_168)
internal val Res.string.review_aspect__gameplay: StringResource by lazy {
      StringResource("string:review_aspect__gameplay", "review_aspect__gameplay", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29674, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27670, 43),
      ))
    }

@delegate:ResourceContentHash(2_074_472_289)
internal val Res.string.review_aspect__longevity: StringResource by lazy {
      StringResource("string:review_aspect__longevity", "review_aspect__longevity", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29718, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27714, 44),
      ))
    }

@delegate:ResourceContentHash(1_200_782_455)
internal val Res.string.review_aspect__story: StringResource by lazy {
      StringResource("string:review_aspect__story", "review_aspect__story", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29767, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27759, 36),
      ))
    }

@delegate:ResourceContentHash(-1_572_335_566)
internal val Res.string.review_aspect__technical: StringResource by lazy {
      StringResource("string:review_aspect__technical", "review_aspect__technical", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29804, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27796, 44),
      ))
    }

@delegate:ResourceContentHash(-135_120_163)
internal val Res.string.search__global_hint: StringResource by lazy {
      StringResource("string:search__global_hint", "search__global_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29861, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27841, 51),
      ))
    }

@delegate:ResourceContentHash(7_976_529)
internal val Res.string.search__scope_games: StringResource by lazy {
      StringResource("string:search__scope_games", "search__scope_games", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29913, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27893, 35),
      ))
    }

@delegate:ResourceContentHash(-737_453_611)
internal val Res.string.search__scope_users: StringResource by lazy {
      StringResource("string:search__scope_users", "search__scope_users", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29949, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27929, 35),
      ))
    }

@delegate:ResourceContentHash(709_720_341)
internal val Res.string.settings__appearance: StringResource by lazy {
      StringResource("string:settings__appearance", "settings__appearance", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30086, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28054, 44),
      ))
    }

@delegate:ResourceContentHash(1_166_012_678)
internal val Res.string.settings__appearance_summary: StringResource by lazy {
      StringResource("string:settings__appearance_summary", "settings__appearance_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 29985, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27965, 88),
      ))
    }

@delegate:ResourceContentHash(-872_206_794)
internal val Res.string.settings__dynamic_colors: StringResource by lazy {
      StringResource("string:settings__dynamic_colors", "settings__dynamic_colors", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30127, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28099, 56),
      ))
    }

@delegate:ResourceContentHash(1_655_569_888)
internal val Res.string.settings__group_account: StringResource by lazy {
      StringResource("string:settings__group_account", "settings__group_account", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30200, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28156, 43),
      ))
    }

@delegate:ResourceContentHash(-1_454_069_218)
internal val Res.string.settings__group_advanced: StringResource by lazy {
      StringResource("string:settings__group_advanced", "settings__group_advanced", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30244, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28200, 44),
      ))
    }

@delegate:ResourceContentHash(79_993_728)
internal val Res.string.settings__group_app: StringResource by lazy {
      StringResource("string:settings__group_app", "settings__group_app", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30289, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28245, 31),
      ))
    }

@delegate:ResourceContentHash(1_275_153_066)
internal val Res.string.settings__import_already_present: StringResource by lazy {
      StringResource("string:settings__import_already_present", "settings__import_already_present", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30321, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28277, 72),
      ))
    }

@delegate:ResourceContentHash(209_227_226)
internal val Res.string.settings__import_cancel: StringResource by lazy {
      StringResource("string:settings__import_cancel", "settings__import_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30394, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28350, 39),
      ))
    }

@delegate:ResourceContentHash(1_614_290_261)
internal val Res.string.settings__import_change_match: StringResource by lazy {
      StringResource("string:settings__import_change_match", "settings__import_change_match", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30438, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28390, 45),
      ))
    }

@delegate:ResourceContentHash(840_865_332)
internal val Res.string.settings__import_confirm: StringResource by lazy {
      StringResource("string:settings__import_confirm", "settings__import_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30563, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28507, 52),
      ))
    }

@delegate:ResourceContentHash(1_680_491_829)
internal val Res.string.settings__import_confirm_match: StringResource by lazy {
      StringResource("string:settings__import_confirm_match", "settings__import_confirm_match", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30484, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28436, 70),
      ))
    }

@delegate:ResourceContentHash(763_993_348)
internal val Res.string.settings__import_deselect_all: StringResource by lazy {
      StringResource("string:settings__import_deselect_all", "settings__import_deselect_all", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30624, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28560, 53),
      ))
    }

@delegate:ResourceContentHash(814_191_629)
internal val Res.string.settings__import_finish: StringResource by lazy {
      StringResource("string:settings__import_finish", "settings__import_finish", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30686, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28614, 39),
      ))
    }

@delegate:ResourceContentHash(718_437_662)
internal val Res.string.settings__import_group_already_present: StringResource by lazy {
      StringResource("string:settings__import_group_already_present", "settings__import_group_already_present", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30726, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28654, 86),
      ))
    }

@delegate:ResourceContentHash(2_057_803_016)
internal val Res.string.settings__import_group_to_import: StringResource by lazy {
      StringResource("string:settings__import_group_to_import", "settings__import_group_to_import", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30809, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28741, 64),
      ))
    }

@delegate:ResourceContentHash(1_592_792_908)
internal val Res.string.settings__import_group_to_review: StringResource by lazy {
      StringResource("string:settings__import_group_to_review", "settings__import_group_to_review", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30878, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28806, 64),
      ))
    }

@delegate:ResourceContentHash(1_294_278_138)
internal val Res.string.settings__import_library_title: StringResource by lazy {
      StringResource("string:settings__import_library_title", "settings__import_library_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 30943, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28871, 58),
      ))
    }

@delegate:ResourceContentHash(-24_546_376)
internal val Res.string.settings__import_no_match: StringResource by lazy {
      StringResource("string:settings__import_no_match", "settings__import_no_match", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31006, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28930, 53),
      ))
    }

@delegate:ResourceContentHash(936_807_685)
internal val Res.string.settings__import_search: StringResource by lazy {
      StringResource("string:settings__import_search", "settings__import_search", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31129, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29041, 39),
      ))
    }

@delegate:ResourceContentHash(922_448_658)
internal val Res.string.settings__import_search_hint: StringResource by lazy {
      StringResource("string:settings__import_search_hint", "settings__import_search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31072, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28984, 56),
      ))
    }

@delegate:ResourceContentHash(1_274_953_186)
internal val Res.string.settings__import_select_all: StringResource by lazy {
      StringResource("string:settings__import_select_all", "settings__import_select_all", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31169, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29081, 51),
      ))
    }

@delegate:ResourceContentHash(561_399_776)
internal val Res.string.settings__import_source: StringResource by lazy {
      StringResource("string:settings__import_source", "settings__import_source", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31225, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29133, 47),
      ))
    }

@delegate:ResourceContentHash(-1_669_613_978)
internal val Res.string.settings__language: StringResource by lazy {
      StringResource("string:settings__language", "settings__language", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31273, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29181, 38),
      ))
    }

@delegate:ResourceContentHash(-997_688_883)
internal val Res.string.settings__linked_services: StringResource by lazy {
      StringResource("string:settings__linked_services", "settings__linked_services", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31563, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29455, 53),
      ))
    }

@delegate:ResourceContentHash(1_427_249_222)
internal val Res.string.settings__linked_services_disclaimer: StringResource by lazy {
      StringResource("string:settings__linked_services_disclaimer", "settings__linked_services_disclaimer", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31308, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29220, 148),
      ))
    }

@delegate:ResourceContentHash(-820_126_375)
internal val Res.string.settings__linked_services_summary: StringResource by lazy {
      StringResource("string:settings__linked_services_summary", "settings__linked_services_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31477, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29369, 85),
      ))
    }

@delegate:ResourceContentHash(1_975_628_511)
internal val Res.string.settings__open_store: StringResource by lazy {
      StringResource("string:settings__open_store", "settings__open_store", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31621, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29509, 48),
      ))
    }

@delegate:ResourceContentHash(-1_119_434_839)
internal val Res.string.settings__rating_scale: StringResource by lazy {
      StringResource("string:settings__rating_scale", "settings__rating_scale", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31682, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29558, 46),
      ))
    }

@delegate:ResourceContentHash(886_421_760)
internal val Res.string.settings__review_mode: StringResource by lazy {
      StringResource("string:settings__review_mode", "settings__review_mode", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31832, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29700, 45),
      ))
    }

@delegate:ResourceContentHash(1_398_992_879)
internal val Res.string.settings__review_mode_basic: StringResource by lazy {
      StringResource("string:settings__review_mode_basic", "settings__review_mode_basic", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31733, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29605, 43),
      ))
    }

@delegate:ResourceContentHash(-88_359_609)
internal val Res.string.settings__review_mode_detailed: StringResource by lazy {
      StringResource("string:settings__review_mode_detailed", "settings__review_mode_detailed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31777, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29649, 50),
      ))
    }

@delegate:ResourceContentHash(879_033_611)
internal val Res.string.settings__reviews: StringResource by lazy {
      StringResource("string:settings__reviews", "settings__reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31886, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29746, 37),
      ))
    }

@delegate:ResourceContentHash(-1_970_378_368)
internal val Res.string.settings__server: StringResource by lazy {
      StringResource("string:settings__server", "settings__server", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33562, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31322, 32),
      ))
    }

@delegate:ResourceContentHash(-1_518_475_567)
internal val Res.string.settings__server_check: StringResource by lazy {
      StringResource("string:settings__server_check", "settings__server_check", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31928, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29784, 38),
      ))
    }

@delegate:ResourceContentHash(-1_435_077_066)
internal val Res.string.settings__server_igdb_follows: StringResource by lazy {
      StringResource("string:settings__server_igdb_follows", "settings__server_igdb_follows", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 31971, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29823, 85),
      ))
    }

@delegate:ResourceContentHash(-1_295_353_305)
internal val Res.string.settings__server_igdb_url: StringResource by lazy {
      StringResource("string:settings__server_igdb_url", "settings__server_igdb_url", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32053, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29909, 49),
      ))
    }

@delegate:ResourceContentHash(-663_247_068)
internal val Res.string.settings__server_restore: StringResource by lazy {
      StringResource("string:settings__server_restore", "settings__server_restore", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32111, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 29959, 56),
      ))
    }

@delegate:ResourceContentHash(313_676_757)
internal val Res.string.settings__server_save: StringResource by lazy {
      StringResource("string:settings__server_save", "settings__server_save", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32176, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30016, 37),
      ))
    }

@delegate:ResourceContentHash(1_714_284_611)
internal val Res.string.settings__server_sign_out_confirm: StringResource by lazy {
      StringResource("string:settings__server_sign_out_confirm", "settings__server_sign_out_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32214, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30054, 69),
      ))
    }

@delegate:ResourceContentHash(-569_180_675)
internal val Res.string.settings__server_sign_out_message: StringResource by lazy {
      StringResource("string:settings__server_sign_out_message", "settings__server_sign_out_message", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32284, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30124, 137),
      ))
    }

@delegate:ResourceContentHash(-206_603_078)
internal val Res.string.settings__server_sign_out_title: StringResource by lazy {
      StringResource("string:settings__server_sign_out_title", "settings__server_sign_out_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32422, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30262, 59),
      ))
    }

@delegate:ResourceContentHash(1_771_184_380)
internal val Res.string.settings__server_status_checking: StringResource by lazy {
      StringResource("string:settings__server_status_checking", "settings__server_status_checking", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32486, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30322, 56),
      ))
    }

@delegate:ResourceContentHash(-612_477_838)
internal val Res.string.settings__server_status_igdb_ok: StringResource by lazy {
      StringResource("string:settings__server_status_igdb_ok", "settings__server_status_igdb_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32555, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30379, 67),
      ))
    }

@delegate:ResourceContentHash(2_106_496_652)
internal val Res.string.settings__server_status_igdb_unexpected: StringResource by lazy {
      StringResource("string:settings__server_status_igdb_unexpected", "settings__server_status_igdb_unexpected", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32631, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30447, 103),
      ))
    }

@delegate:ResourceContentHash(1_857_476_476)
internal val Res.string.settings__server_status_invalid: StringResource by lazy {
      StringResource("string:settings__server_status_invalid", "settings__server_status_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32735, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30551, 95),
      ))
    }

@delegate:ResourceContentHash(1_650_347_623)
internal val Res.string.settings__server_status_server_ok: StringResource by lazy {
      StringResource("string:settings__server_status_server_ok", "settings__server_status_server_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32843, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30647, 77),
      ))
    }

@delegate:ResourceContentHash(-216_955_395)
internal val Res.string.settings__server_status_server_unexpected: StringResource by lazy {
      StringResource("string:settings__server_status_server_unexpected", "settings__server_status_server_unexpected", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 32929, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30725, 109),
      ))
    }

@delegate:ResourceContentHash(-17_214_991)
internal val Res.string.settings__server_status_unreachable: StringResource by lazy {
      StringResource("string:settings__server_status_unreachable", "settings__server_status_unreachable", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33039, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30835, 59),
      ))
    }

@delegate:ResourceContentHash(1_364_811_117)
internal val Res.string.settings__server_summary: StringResource by lazy {
      StringResource("string:settings__server_summary", "settings__server_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33107, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30895, 84),
      ))
    }

@delegate:ResourceContentHash(456_417_641)
internal val Res.string.settings__server_url: StringResource by lazy {
      StringResource("string:settings__server_url", "settings__server_url", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33188, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 30980, 56),
      ))
    }

@delegate:ResourceContentHash(1_755_206_117)
internal val Res.string.settings__server_warning: StringResource by lazy {
      StringResource("string:settings__server_warning", "settings__server_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33253, 308),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31037, 284),
      ))
    }

@delegate:ResourceContentHash(-2_108_665_431)
internal val Res.string.settings__service_connect: StringResource by lazy {
      StringResource("string:settings__service_connect", "settings__service_connect", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33595, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31355, 45),
      ))
    }

@delegate:ResourceContentHash(-1_320_644_282)
internal val Res.string.settings__service_disconnect: StringResource by lazy {
      StringResource("string:settings__service_disconnect", "settings__service_disconnect", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33641, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31401, 52),
      ))
    }

@delegate:ResourceContentHash(-1_634_359_072)
internal val Res.string.settings__service_epic: StringResource by lazy {
      StringResource("string:settings__service_epic", "settings__service_epic", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33690, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31454, 46),
      ))
    }

@delegate:ResourceContentHash(79_706_528)
internal val Res.string.settings__service_gog: StringResource by lazy {
      StringResource("string:settings__service_gog", "settings__service_gog", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33737, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31501, 33),
      ))
    }

@delegate:ResourceContentHash(1_294_278_138)
internal val Res.string.settings__service_import_library: StringResource by lazy {
      StringResource("string:settings__service_import_library", "settings__service_import_library", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33771, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31535, 60),
      ))
    }

@delegate:ResourceContentHash(-1_039_165_302)
internal val Res.string.settings__service_login_required: StringResource by lazy {
      StringResource("string:settings__service_login_required", "settings__service_login_required", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33836, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31596, 68),
      ))
    }

@delegate:ResourceContentHash(-485_946_688)
internal val Res.string.settings__service_nintendo: StringResource by lazy {
      StringResource("string:settings__service_nintendo", "settings__service_nintendo", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33905, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31665, 46),
      ))
    }

@delegate:ResourceContentHash(-279_110_687)
internal val Res.string.settings__service_pc_only: StringResource by lazy {
      StringResource("string:settings__service_pc_only", "settings__service_pc_only", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33952, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31712, 45),
      ))
    }

@delegate:ResourceContentHash(1_557_946_606)
internal val Res.string.settings__service_phase_logged_in: StringResource by lazy {
      StringResource("string:settings__service_phase_logged_in", "settings__service_phase_logged_in", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 33998, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31758, 53),
      ))
    }

@delegate:ResourceContentHash(-432_484_572)
internal val Res.string.settings__service_phase_reading: StringResource by lazy {
      StringResource("string:settings__service_phase_reading", "settings__service_phase_reading", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34064, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31812, 67),
      ))
    }

@delegate:ResourceContentHash(44_468_640)
internal val Res.string.settings__service_playstation: StringResource by lazy {
      StringResource("string:settings__service_playstation", "settings__service_playstation", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34140, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31880, 53),
      ))
    }

@delegate:ResourceContentHash(-1_101_161_143)
internal val Res.string.settings__service_refresh_profile: StringResource by lazy {
      StringResource("string:settings__service_refresh_profile", "settings__service_refresh_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34194, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31934, 61),
      ))
    }

@delegate:ResourceContentHash(894_984_288)
internal val Res.string.settings__service_steam: StringResource by lazy {
      StringResource("string:settings__service_steam", "settings__service_steam", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34260, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 31996, 39),
      ))
    }

@delegate:ResourceContentHash(-1_504_324_758)
internal val Res.string.settings__service_sync_added: StringResource by lazy {
      StringResource("string:settings__service_sync_added", "settings__service_sync_added", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34300, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32036, 64),
      ))
    }

@delegate:ResourceContentHash(1_545_179_063)
internal val Res.string.settings__service_sync_error: StringResource by lazy {
      StringResource("string:settings__service_sync_error", "settings__service_sync_error", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34369, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32101, 68),
      ))
    }

@delegate:ResourceContentHash(1_423_050_731)
internal val Res.string.settings__service_sync_now: StringResource by lazy {
      StringResource("string:settings__service_sync_now", "settings__service_sync_now", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34454, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32170, 46),
      ))
    }

@delegate:ResourceContentHash(1_669_067_548)
internal val Res.string.settings__service_sync_pushed: StringResource by lazy {
      StringResource("string:settings__service_sync_pushed", "settings__service_sync_pushed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34509, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32217, 61),
      ))
    }

@delegate:ResourceContentHash(1_313_048_426)
internal val Res.string.settings__service_sync_summary: StringResource by lazy {
      StringResource("string:settings__service_sync_summary", "settings__service_sync_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34571, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32279, 58),
      ))
    }

@delegate:ResourceContentHash(-844_292_481)
internal val Res.string.settings__service_sync_wishlist: StringResource by lazy {
      StringResource("string:settings__service_sync_wishlist", "settings__service_sync_wishlist", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34642, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32338, 59),
      ))
    }

@delegate:ResourceContentHash(1_483_813_696)
internal val Res.string.settings__service_ubisoft: StringResource by lazy {
      StringResource("string:settings__service_ubisoft", "settings__service_ubisoft", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34710, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32398, 53),
      ))
    }

@delegate:ResourceContentHash(444_165_175)
internal val Res.string.settings__service_web_unsupported: StringResource by lazy {
      StringResource("string:settings__service_web_unsupported", "settings__service_web_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34764, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32452, 173),
      ))
    }

@delegate:ResourceContentHash(-764_006_252)
internal val Res.string.settings__service_webview_busy: StringResource by lazy {
      StringResource("string:settings__service_webview_busy", "settings__service_webview_busy", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 34958, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32626, 122),
      ))
    }

@delegate:ResourceContentHash(-1_764_730_798)
internal val Res.string.settings__service_working: StringResource by lazy {
      StringResource("string:settings__service_working", "settings__service_working", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35077, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32749, 49),
      ))
    }

@delegate:ResourceContentHash(-895_423_744)
internal val Res.string.settings__service_xbox: StringResource by lazy {
      StringResource("string:settings__service_xbox", "settings__service_xbox", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35143, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32799, 38),
      ))
    }

@delegate:ResourceContentHash(-1_055_754_812)
internal val Res.string.settings__sync_title_connect: StringResource by lazy {
      StringResource("string:settings__sync_title_connect", "settings__sync_title_connect", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35182, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32838, 52),
      ))
    }

@delegate:ResourceContentHash(-113_171_364)
internal val Res.string.settings__sync_title_import_library: StringResource by lazy {
      StringResource("string:settings__sync_title_import_library", "settings__sync_title_import_library", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35231, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32891, 67),
      ))
    }

@delegate:ResourceContentHash(-1_130_568_060)
internal val Res.string.settings__sync_title_refresh_profile: StringResource by lazy {
      StringResource("string:settings__sync_title_refresh_profile", "settings__sync_title_refresh_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35303, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32959, 68),
      ))
    }

@delegate:ResourceContentHash(-1_682_313_276)
internal val Res.string.settings__sync_title_sync_wishlist: StringResource by lazy {
      StringResource("string:settings__sync_title_sync_wishlist", "settings__sync_title_sync_wishlist", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35376, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33028, 66),
      ))
    }

@delegate:ResourceContentHash(2_011_037_899)
internal val Res.string.settings__theme: StringResource by lazy {
      StringResource("string:settings__theme", "settings__theme", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35573, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33209, 31),
      ))
    }

@delegate:ResourceContentHash(1_818_338_383)
internal val Res.string.settings__theme_dark: StringResource by lazy {
      StringResource("string:settings__theme_dark", "settings__theme_dark", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35455, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33095, 36),
      ))
    }

@delegate:ResourceContentHash(-174_333_836)
internal val Res.string.settings__theme_light: StringResource by lazy {
      StringResource("string:settings__theme_light", "settings__theme_light", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35492, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33132, 37),
      ))
    }

@delegate:ResourceContentHash(-16_358_135)
internal val Res.string.settings__theme_system: StringResource by lazy {
      StringResource("string:settings__theme_system", "settings__theme_system", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35530, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33170, 38),
      ))
    }

@delegate:ResourceContentHash(1_073_004_323)
internal val Res.string.settings__wishlist_already_present: StringResource by lazy {
      StringResource("string:settings__wishlist_already_present", "settings__wishlist_already_present", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35605, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33241, 70),
      ))
    }

@delegate:ResourceContentHash(-1_486_586_752)
internal val Res.string.settings__wishlist_preview_title: StringResource by lazy {
      StringResource("string:settings__wishlist_preview_title", "settings__wishlist_preview_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35676, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33312, 52),
      ))
    }

@delegate:ResourceContentHash(-1_421_881_521)
internal val Res.string.settings__wishlist_push_confirm: StringResource by lazy {
      StringResource("string:settings__wishlist_push_confirm", "settings__wishlist_push_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35729, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33365, 43),
      ))
    }

@delegate:ResourceContentHash(773_046_686)
internal val Res.string.settings__wishlist_push_off_platform: StringResource by lazy {
      StringResource("string:settings__wishlist_push_off_platform", "settings__wishlist_push_off_platform", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35781, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33409, 84),
      ))
    }

@delegate:ResourceContentHash(1_686_996_690)
internal val Res.string.settings__wishlist_push_skip: StringResource by lazy {
      StringResource("string:settings__wishlist_push_skip", "settings__wishlist_push_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35878, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33494, 44),
      ))
    }

@delegate:ResourceContentHash(-266_105_854)
internal val Res.string.settings__wishlist_push_title: StringResource by lazy {
      StringResource("string:settings__wishlist_push_title", "settings__wishlist_push_title", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 35923, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33539, 65),
      ))
    }

@delegate:ResourceContentHash(-1_398_099_406)
internal val Res.string.social__feed: StringResource by lazy {
      StringResource("string:social__feed", "social__feed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36164, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33768, 52),
      ))
    }

@delegate:ResourceContentHash(-441_083_981)
internal val Res.string.social__feed_empty: StringResource by lazy {
      StringResource("string:social__feed_empty", "social__feed_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36097, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33689, 78),
      ))
    }

@delegate:ResourceContentHash(1_054_989_221)
internal val Res.string.social__feed_empty_hint: StringResource by lazy {
      StringResource("string:social__feed_empty_hint", "social__feed_empty_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36009, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33605, 83),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString5Resources(map: MutableMap<String, StringResource>) {
  map.put("review_aspect__cast", Res.string.review_aspect__cast)
  map.put("review_aspect__gameplay", Res.string.review_aspect__gameplay)
  map.put("review_aspect__longevity", Res.string.review_aspect__longevity)
  map.put("review_aspect__story", Res.string.review_aspect__story)
  map.put("review_aspect__technical", Res.string.review_aspect__technical)
  map.put("search__global_hint", Res.string.search__global_hint)
  map.put("search__scope_games", Res.string.search__scope_games)
  map.put("search__scope_users", Res.string.search__scope_users)
  map.put("settings__appearance", Res.string.settings__appearance)
  map.put("settings__appearance_summary", Res.string.settings__appearance_summary)
  map.put("settings__dynamic_colors", Res.string.settings__dynamic_colors)
  map.put("settings__group_account", Res.string.settings__group_account)
  map.put("settings__group_advanced", Res.string.settings__group_advanced)
  map.put("settings__group_app", Res.string.settings__group_app)
  map.put("settings__import_already_present", Res.string.settings__import_already_present)
  map.put("settings__import_cancel", Res.string.settings__import_cancel)
  map.put("settings__import_change_match", Res.string.settings__import_change_match)
  map.put("settings__import_confirm", Res.string.settings__import_confirm)
  map.put("settings__import_confirm_match", Res.string.settings__import_confirm_match)
  map.put("settings__import_deselect_all", Res.string.settings__import_deselect_all)
  map.put("settings__import_finish", Res.string.settings__import_finish)
  map.put("settings__import_group_already_present", Res.string.settings__import_group_already_present)
  map.put("settings__import_group_to_import", Res.string.settings__import_group_to_import)
  map.put("settings__import_group_to_review", Res.string.settings__import_group_to_review)
  map.put("settings__import_library_title", Res.string.settings__import_library_title)
  map.put("settings__import_no_match", Res.string.settings__import_no_match)
  map.put("settings__import_search", Res.string.settings__import_search)
  map.put("settings__import_search_hint", Res.string.settings__import_search_hint)
  map.put("settings__import_select_all", Res.string.settings__import_select_all)
  map.put("settings__import_source", Res.string.settings__import_source)
  map.put("settings__language", Res.string.settings__language)
  map.put("settings__linked_services", Res.string.settings__linked_services)
  map.put("settings__linked_services_disclaimer", Res.string.settings__linked_services_disclaimer)
  map.put("settings__linked_services_summary", Res.string.settings__linked_services_summary)
  map.put("settings__open_store", Res.string.settings__open_store)
  map.put("settings__rating_scale", Res.string.settings__rating_scale)
  map.put("settings__review_mode", Res.string.settings__review_mode)
  map.put("settings__review_mode_basic", Res.string.settings__review_mode_basic)
  map.put("settings__review_mode_detailed", Res.string.settings__review_mode_detailed)
  map.put("settings__reviews", Res.string.settings__reviews)
  map.put("settings__server", Res.string.settings__server)
  map.put("settings__server_check", Res.string.settings__server_check)
  map.put("settings__server_igdb_follows", Res.string.settings__server_igdb_follows)
  map.put("settings__server_igdb_url", Res.string.settings__server_igdb_url)
  map.put("settings__server_restore", Res.string.settings__server_restore)
  map.put("settings__server_save", Res.string.settings__server_save)
  map.put("settings__server_sign_out_confirm", Res.string.settings__server_sign_out_confirm)
  map.put("settings__server_sign_out_message", Res.string.settings__server_sign_out_message)
  map.put("settings__server_sign_out_title", Res.string.settings__server_sign_out_title)
  map.put("settings__server_status_checking", Res.string.settings__server_status_checking)
  map.put("settings__server_status_igdb_ok", Res.string.settings__server_status_igdb_ok)
  map.put("settings__server_status_igdb_unexpected", Res.string.settings__server_status_igdb_unexpected)
  map.put("settings__server_status_invalid", Res.string.settings__server_status_invalid)
  map.put("settings__server_status_server_ok", Res.string.settings__server_status_server_ok)
  map.put("settings__server_status_server_unexpected", Res.string.settings__server_status_server_unexpected)
  map.put("settings__server_status_unreachable", Res.string.settings__server_status_unreachable)
  map.put("settings__server_summary", Res.string.settings__server_summary)
  map.put("settings__server_url", Res.string.settings__server_url)
  map.put("settings__server_warning", Res.string.settings__server_warning)
  map.put("settings__service_connect", Res.string.settings__service_connect)
  map.put("settings__service_disconnect", Res.string.settings__service_disconnect)
  map.put("settings__service_epic", Res.string.settings__service_epic)
  map.put("settings__service_gog", Res.string.settings__service_gog)
  map.put("settings__service_import_library", Res.string.settings__service_import_library)
  map.put("settings__service_login_required", Res.string.settings__service_login_required)
  map.put("settings__service_nintendo", Res.string.settings__service_nintendo)
  map.put("settings__service_pc_only", Res.string.settings__service_pc_only)
  map.put("settings__service_phase_logged_in", Res.string.settings__service_phase_logged_in)
  map.put("settings__service_phase_reading", Res.string.settings__service_phase_reading)
  map.put("settings__service_playstation", Res.string.settings__service_playstation)
  map.put("settings__service_refresh_profile", Res.string.settings__service_refresh_profile)
  map.put("settings__service_steam", Res.string.settings__service_steam)
  map.put("settings__service_sync_added", Res.string.settings__service_sync_added)
  map.put("settings__service_sync_error", Res.string.settings__service_sync_error)
  map.put("settings__service_sync_now", Res.string.settings__service_sync_now)
  map.put("settings__service_sync_pushed", Res.string.settings__service_sync_pushed)
  map.put("settings__service_sync_summary", Res.string.settings__service_sync_summary)
  map.put("settings__service_sync_wishlist", Res.string.settings__service_sync_wishlist)
  map.put("settings__service_ubisoft", Res.string.settings__service_ubisoft)
  map.put("settings__service_web_unsupported", Res.string.settings__service_web_unsupported)
  map.put("settings__service_webview_busy", Res.string.settings__service_webview_busy)
  map.put("settings__service_working", Res.string.settings__service_working)
  map.put("settings__service_xbox", Res.string.settings__service_xbox)
  map.put("settings__sync_title_connect", Res.string.settings__sync_title_connect)
  map.put("settings__sync_title_import_library", Res.string.settings__sync_title_import_library)
  map.put("settings__sync_title_refresh_profile", Res.string.settings__sync_title_refresh_profile)
  map.put("settings__sync_title_sync_wishlist", Res.string.settings__sync_title_sync_wishlist)
  map.put("settings__theme", Res.string.settings__theme)
  map.put("settings__theme_dark", Res.string.settings__theme_dark)
  map.put("settings__theme_light", Res.string.settings__theme_light)
  map.put("settings__theme_system", Res.string.settings__theme_system)
  map.put("settings__wishlist_already_present", Res.string.settings__wishlist_already_present)
  map.put("settings__wishlist_preview_title", Res.string.settings__wishlist_preview_title)
  map.put("settings__wishlist_push_confirm", Res.string.settings__wishlist_push_confirm)
  map.put("settings__wishlist_push_off_platform", Res.string.settings__wishlist_push_off_platform)
  map.put("settings__wishlist_push_skip", Res.string.settings__wishlist_push_skip)
  map.put("settings__wishlist_push_title", Res.string.settings__wishlist_push_title)
  map.put("social__feed", Res.string.social__feed)
  map.put("social__feed_empty", Res.string.social__feed_empty)
  map.put("social__feed_empty_hint", Res.string.social__feed_empty_hint)
}
